import { Link } from "react-router-dom";

const footerLinks = {
  navigation: [
    { name: "首页", path: "/" },
    { name: "电影", path: "/category/movie" },
    { name: "电视剧", path: "/category/tv" },
    { name: "综艺", path: "/category/variety" },
    { name: "动漫", path: "/category/anime" },
    { name: "纪录片", path: "/category/documentary" },
    { name: "短视频", path: "/category/short" },
  ],
  about: [
    { name: "关于我们", path: "/about" },
    { name: "品牌介绍", path: "/about" },
    { name: "联系方式", path: "/about" },
    { name: "用户口碑", path: "/about" },
  ],
  hotTags: [
    "91年国产影片视频",
    "91传媒视频在线",
    "91精彩视频在线观看",
    "影视网站免费观看",
    "热门影视在线",
    "在线视频平台",
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/3">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-xl"></i>
                </div>
                <span className="font-heading font-bold text-xl text-background-50 whitespace-nowrap">
                  91麻豆免费视频
                </span>
              </Link>
              <p className="text-background-400 text-sm leading-relaxed mb-5 max-w-sm">
                91麻豆免费视频网站打造综合性影视在线观看平台，集合91年国产影片视频、91传媒视频在线、91精彩视频在线观看等频道，影视网站免费观看热门影视在线，在线视频平台电影电视剧综艺全覆盖。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-200 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-200 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-background-200 text-sm"></i>
                </a>
              </div>
            </div>

            <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
              <div>
                <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                  快速导航
                </h4>
                <ul className="space-y-2.5">
                  {footerLinks.navigation.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                  关于我们
                </h4>
                <ul className="space-y-2.5">
                  {footerLinks.about.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-span-2 md:col-span-1">
                <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                  热门标签
                </h4>
                <div className="flex flex-wrap gap-2">
                  {footerLinks.hotTags.map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1.5 rounded-md bg-background-800 text-background-400 text-xs whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-background-500 text-xs">
              &copy; {new Date().getFullYear()} 91麻豆免费视频网站 版权所有
            </p>
            <div className="flex items-center gap-4 text-background-500 text-xs">
              <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户协议</a>
              <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}